import { Button } from 'antd';
import React from 'react';
import { Carousel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import './seccionesFicha.css'

const Recomendados = ({ recomendados }) => {

    let cantidadCard = recomendados.length >= 2 ? 2 : recomendados.length < 2 && 1;
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: cantidadCard,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 1360,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            }
        ]
    };
    return (
        <>
            <Slider {...settings} className="slider-multiple my-5 d-none d-md-block">
                {recomendados && recomendados.length > 0 &&
                    recomendados.map((recomendado, i) => <CardRecomendados recomendado={recomendado} key={i} />)
                }
            </Slider>
            <Carousel className="d-md-none carousel-primario">
                {recomendados && recomendados.length > 0 &&
                    recomendados.map((recomendado, i) =>
                        <Carousel.Item key={i}>
                            <CardRecomendados recomendado={recomendado} key={i} />
                        </Carousel.Item>)
                }

            </Carousel>
        </>
    );
}


const CardRecomendados = ({ recomendado }) => {

    if(!recomendado) return null;
    return (
        <>
            <Row className="px-5 my-3 mb-5 d-none d-md-flex border-right-apl">
                <Col md={5} className="text-center">
                    <img src={recomendado.Imagen} className="img-fluid" alt={recomendado.Nombre} />
                </Col>
                <Col md={7} className="my-3">
                    <h6 className="bold-title-hyundai mb-1">{recomendado.Nombre}</h6>
                    <p className="parrafo-hyundai mb-3">{recomendado.Version !== null ? recomendado.Version : "Versión"}</p>
                    <Row className="px-3">
                    {recomendado.caracteristicas && recomendado.caracteristicas.length > 0 &&
                        recomendado.caracteristicas.map((caracteristica, i) =>
                            <Col className={`text-center mx-auto my-3 caracteristica-recomendado ${i + 1 < recomendado.caracteristicas.length && "border-intermedio"}`} key={i}>
                               <img src={caracteristica.Imagen} alt="info" className="d-inline mr-2 my-3" width="20px" height="20px"/><p className="parrafo-hyundai d-inline my-2">{caracteristica.Descripcion}</p>
                            </Col>
                        )
                    }
                    </Row>
                    <Row className="mt-3">
                        <Col md={6} className="pr-1">
                            <Button className="w-100 mb-2 btn-primario">Cotizar</Button>
                        </Col>
                        <Col md={6} className="pl-1">
                            <Link to={`/vehiculo/${recomendado.Slug}`}>
                                <Button className="w-100 mb-2 btn-secundario">Ver ficha</Button>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="d-md-none mt-4 mb-4">
                <Col xs={7} className="mx-auto">
                    <h6 className="bold-title-hyundai f-responsive-14 mb-0">{recomendado.Nombre}</h6>
                    <p className="parrafo-hyundai f-responsive">{recomendado.Version !== null ? recomendado.Version : "-"}</p>
                    <Row>
                    {recomendado.caracteristicas && recomendado.caracteristicas.length > 0 &&
                        recomendado.caracteristicas.map((caracteristica, i) =>
                            <Col className={`text-center mx-auto caracteristica-recomendado ${i + 1 < recomendado.caracteristicas.length && "border-intermedio"}`} key={i}>
                               <img src={caracteristica.Imagen} alt={caracteristica.Descripcion} className="mr-1 mr-md-1 my-0 my-md-2 img-caracteristicas"/><p className="parrafo-hyundai d-inline my-3 f-responsive-10">{caracteristica.Descripcion}</p>
                            </Col>
                        )
                    }
                    </Row>
                    <img src={recomendado.Imagen} className="img-fluid mt-3"  alt={recomendado.Nombre}/>
                    
                    <Link to={`/vehiculo/${recomendado.Slug}`}>
                        <Button className="w-100 mt-4 mb-4 btn-primario font-btn">Ver más</Button>
                    </Link>
                </Col>
            </Row>
        </>
    )
}

export default Recomendados;